import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Button, Divider } from "@mui/material";
import IconBar from "../Partials/IconBar";
import { urlbase, headers } from "../../constants/Constants";

export default function TestStartScreen(props) {
  const history = useHistory();

  const user = props.location.state.user;
  const test = props.location.state.test;
  const grouptest = props.location.state.grouptest;
  localStorage.setItem("QuestionNumber", "0");
  localStorage.setItem("Submission", "");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onClick = async () => {
    const url = urlbase().concat(
      "test/questions?token="
        .concat(user.token)
        .concat("&test_id=")
        .concat(test.id)
    );
    await fetch(url, {
      method: "GET",
      headers: headers(),
    })
      .then((response) => response.json())
      .then((data) => {
        const questions = randomizeQuestions(data);
        var randomOptions = [];

        for (var x = 0; x < questions.length; x++) {
          randomOptions[x] = RandomizeOptions(questions[x]);
        }

        var temp = JSON.stringify(randomOptions);
        localStorage.setItem("Options", temp);

        history.push("test", {
          user: user,
          test: test,
          questions: questions,
          grouptest: grouptest,
        });
      })
      .catch((response) => {
        console.log(response);
        return <></>;
      });
  };

  function randomizeQuestions(qs) {
    var tempArr = [];
    var list = [];
    for (var x = 0; x < qs.length; x++) {
      list[x] = x;
    }
    list = list.sort(() => Math.random() - 0.5);

    for (var x = 0; x < list.length; x++) {
      var y = list[x];
      tempArr[x] = qs[y];
    }

    return tempArr;
  }

  function timeFromMinutes(value) {
    var final = "";
    if (value < 60) {
      final = value.toString().concat(" minutes");
    } else {
      const minutes = value % 60;
      const hours = (value - minutes) / 60;
      final = hours
        .toString()
        .concat(" hours ")
        .concat(minutes.toString())
        .concat(" minutes");
    }
    return final;
  }

  localStorage.setItem("StartTime", "");

  function RandomizeOptions(question) {
    var tempArr = [];
    if (
      question.type !== "text" &&
      question.type !== "true/false" &&
      question.type !== "order" &&
      question.type !== "match"
    ) {
      var list = [];
      for (var x = 0; x < question.options.length; x++) {
        list[x] = x;
      }
      list = list.sort(() => Math.random() - 0.5);

      for (var x = 0; x < list.length; x++) {
        var temp = list[x];
        tempArr[x] = question.options[temp];
      }
    }

    if (
      question.type === "match" ||
      question.type === "order" ||
      question.type === "true/false"
    ) {
      for (var x = 0; x < question.options.length; x++) {
        tempArr[x] = question.options[x];
      }
    }

    return tempArr;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px",
        width: windowWidth >= 800 ? "50%" : "90%",
      }}
    >
      <IconBar location={"testStart"} user={user} />

      <Box
        sx={{
          padding: "20px",
          backgroundColor: "#212a41",
          borderRadius: "5px",
          width: "90%",
          marginTop: "15px",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "#FBCD02",
            fontWeight: "bold",
            marginBottom: "20px",
          }}
          fontSize="1.1rem"
        >
          {test.name}
        </Typography>
        {/* <Divider sx={{ margin: "10px 0", bgcolor: "white" }} /> */}
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "5px",
            padding: "10px 0px",
            marginBottom: "10px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#00112e",
              fontWeight: "bold",
            }}
          >
            {test.area}: {test.module}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#00112e",
              fontWeight: "bold",
            }}
          >
            {test.section}
          </Typography>
        </div>
        {/* <Divider sx={{ margin: "10px 0", bgcolor: "white" }} /> */}
        <Typography variant="body1" color="white" textAlign={"left"}>
          <div
            style={{ color: "#FBCD02", fontWeight: "bold", marginTop: "20px" }}
          >
            Description:
          </div>
          Grade: {test.grade}
          <br />
          Difficulty: {test.difficulty}
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
          }}
        >
          Allocated Time: &nbsp;
          {/* Adding a non-breaking space for spacing */}
          <Typography variant="body1" color="white">
            {timeFromMinutes(test.timealloc)}
          </Typography>
        </Typography>

        <Typography
          variant="body1"
          color="white"
          textAlign={"left"}
          marginBottom={"20px"}
        >
          Total Questions: {test.numQuestions} Questions
        </Typography>
        <Button
          variant="contained"
          sx={{
            width: "100%",
            height: "3em",
            backgroundColor: "#FBCD02",
            color: "#00112e",
            borderRadius: "5px",
            marginTop: "10px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#FBCD02",
            },
          }}
          onClick={onClick}
        >
          START
        </Button>
      </Box>
    </Box>
  );
}
